import {ReactNode} from "react";
import ExtendTheme from "./ExtendTheme";
import {rootConfig} from "../components/ui/theme";

export default function RootTheme({children}: {children?: ReactNode}) {
  return <ExtendTheme extension={rootConfig}>{children}</ExtendTheme>;
}
